import { AskableIconLoading } from '@askable/ui/core/askable-icon';
import { useKindeBrowserClient } from '@kinde-oss/kinde-auth-nextjs';
import { useState, useEffect } from 'react';

import { AUTH_CONFIG } from '@/src/network/auth';
import { hasEmbeddedParticipantSession } from '@/utils/hasEmbeddedParticipantSession';

import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

export const SetUpKinde = ({ children }: Props) => {
  const { getToken, isLoading, isAuthenticated, refreshData } = useKindeBrowserClient();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (isAuthenticated && !hasEmbeddedParticipantSession()) {
      AUTH_CONFIG.getToken = getToken;
      // Force Kinde to refresh the token then return the fresh value, so the
      // URQL `authExchange.refreshAuth` actually has a way to recover from an
      // expired token.
      AUTH_CONFIG.refreshToken = async () => {
        await refreshData();
        return getToken() ?? undefined;
      };
    }

    setReady(true);
  }, [isLoading]);

  if (!ready) {
    return <AskableIconLoading isFullScreen />;
  }

  return children;
};
